<template>
    <div class="login_container">
        <div class="img_container"></div>
        <div class="form_container">
            <div class="page_name">
                <h1>欢迎访问！</h1>
                <p>请登录您的账户以查看舆情资讯</p>
            </div>
            <div class="form_box">
                <el-form :model="formData" autocomplete="off">
                    <ul>
                        <el-form-item>
                            <li>
                                <div class="icon"><i class="iconfont icon-xinxi_huaban"></i></div>
                                <div class="inp">
                                    <AnimationInput type="text" v-model.trim="formData.loginName" name="loginName" maxlength="32" placeholder="邮箱账号" />
                                </div>
                            </li>
                        </el-form-item>
                        <el-form-item>
                            <li>
                                <div class="icon"><i class="iconfont icon-06"></i></div>
                                <div class="inp">
                                    <AnimationInput type="password" v-model.trim="formData.password" name="password" maxlength="32" placeholder="密码" />
                                </div>
                            </li>
                        </el-form-item>
                    </ul>
                    <div class="btn_row">
                        <button class="btn" @click.prevent="onLogin">登&nbsp;&nbsp;&nbsp;&nbsp;录</button>
                    </div>
                    <div class="link_row">
                        <router-link to="/password/username">忘记密码？</router-link>
                    </div>
                    <div class="btn_row create">
                        <button class="btn" @click.prevent="toReg">创建账户</button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
    <!-- 定期验证弹框 -->
    <ValidateDialog :show="show" :params="params" @close="close" />
</template>

<script setup>
import { reactive, computed } from "vue";
import { apiAuthLogin, apiAuthLoginEmail } from "@/request/api";
import { ElMessage } from "element-plus";
import withLoading from "@/utils/loading";
import { setStorage } from "@/utils";
import { useRouter } from "vue-router";
import ValidateDialog from "./validate-dialog/index.vue";
import useValidate from "./validate-dialog/useValidate";
import AnimationInput from "@/components/common/AnimationInput.vue";
import md5 from "md5";
import useCompanyInfo from "@/utils/useCompanyInfo";
import useTip from "@/store/modules/useTip";

const tipStore = useTip();
const router = useRouter();
const formData = reactive({
    domain: location.host,
    loginName: "",
    password: "",
});
const params = computed(() => {
    const { domain, loginName, password } = formData;
    return {
        domain,
        loginName,
        password: md5(password).toLocaleLowerCase(),
    };
});

// 公司信息
const { companyInfo } = useCompanyInfo();

// 登录
function onLogin() {
    const { loginName, password } = formData;
    const { emailSuffix } = companyInfo.value;
    if (!loginName) {
        ElMessage.error("请输入邮箱账号");
        return;
    }
    if (emailSuffix && !loginName.endsWith(emailSuffix) && !loginName.endsWith("@goalyeah.com")) {
        ElMessage.error("公司邮箱后缀错误");
        return;
    }
    if (!password) {
        ElMessage.error("请输入密码");
        return;
    }
    tipStore.setTiped("N");
    login();
}

// 登录请求
async function login() {
    const { code, data } = await withLoading(apiAuthLogin, { text: "登录中..." })(params.value);
    if (code !== "0") return;
    if (data.valid) {
        apiAuthLoginEmail(params.value); // 发送验证码
        open();
        return;
    }
    router.replace("/");
    setStorage("token", data.token);
    setStorage("userName", data.userName);
}

// 定期验证
const { show, open, close } = useValidate();

// 注册
function toReg() {
    router.push("/reg");
}
</script>

<style lang="scss" scoped>
.login_container {
    height: 100vh;
    display: flex;
    background-color: #fff;

    .img_container {
        width: 40%;
        background: url(~@/assets/img/passport_back.png) center;
    }
    .form_container {
        width: 60%;
        height: 100%;
        padding: 0 12%;
        padding-top: 16vh;
        overflow-y: auto;

        .page_name {
            h1 {
                color: #2a2a2a;
                font-size: 32px;
                line-height: 40px;
                font-weight: 400;
            }
            p {
                color: #727272;
                font-size: 20px;
                line-height: 24px;
                padding-top: 20px;
            }
        }

        .form_box {
            padding-top: 20px;

            ul {
                li {
                    display: flex;
                    margin-top: 60px;
                    &:first-child {
                        margin-top: 52px;
                    }
                    .icon {
                        width: 68px;
                        height: 68px;
                        background-color: #ffeee4;
                        border-radius: 8px;
                        margin-right: 24px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .iconfont {
                            font-size: 22px;
                            color: var(--week-primary-color);
                        }
                    }
                    .inp {
                        flex: 1;
                    }
                }
            }

            .btn_row {
                margin-top: 40px;

                .btn {
                    width: 100%;
                    height: 68px;
                    line-height: 48px;
                    border-radius: 4px;
                    background: var(--week-primary-color);
                    color: #fff;
                    font-size: 20px;
                }
                &.create {
                    margin-top: 0;
                    .btn {
                        background-color: #ffeee4;
                        color: var(--week-primary-color);
                    }
                }
            }
        }

        .link_row {
            text-align: center;

            a {
                color: #727272;
                font-size: 16px;
                line-height: 72px;
            }
        }
    }
}
</style>
